import type { Option } from '@joor/design-system'

/**
 * Countries supported by Tax ID Pro validation (`country` query param).
 */
export const taxIdProValidCountries: Option[] = [
  { label: 'Albania', value: 'al' },
  { label: 'Andorra', value: 'ad' },
  { label: 'Anguilla', value: 'ai' },
  { label: 'Antigua and Barbuda', value: 'ag' },
  { label: 'Argentina', value: 'ar' },
  { label: 'Armenia', value: 'am' },
  { label: 'Aruba', value: 'aw' },
  { label: 'Australia', value: 'au' },
  { label: 'Austria', value: 'at' },
  { label: 'Azerbaijan', value: 'az' },
  { label: 'Bangladesh', value: 'bd' },
  { label: 'Barbados', value: 'bb' },
  { label: 'Belarus', value: 'by' },
  { label: 'Belgium', value: 'be' },
  { label: 'Belize', value: 'bz' },
  { label: 'Bolivia', value: 'bo' },
  { label: 'Brazil', value: 'br' },
  { label: 'Brunei', value: 'bn' },
  { label: 'Bulgaria', value: 'bg' },
  { label: 'Canada', value: 'ca' },
  { label: 'Chile', value: 'cl' },
  { label: 'China', value: 'cn' },
  { label: 'Colombia', value: 'co' },
  { label: 'Cook Islands', value: 'ck' },
  { label: 'Costa Rica', value: 'cr' },
  { label: 'Croatia', value: 'hr' },
  { label: 'Cuba', value: 'cu' },
  { label: 'Curacao', value: 'cw' },
  { label: 'Cyprus', value: 'cy' },
  { label: 'Czech Republic', value: 'cz' },
  { label: 'Denmark', value: 'dk' },
  { label: 'Dominican Rep', value: 'do' },
  { label: 'Ecuador', value: 'ec' },
  { label: 'Egypt', value: 'eg' },
  { label: 'El Salvador', value: 'sv' },
  { label: 'Estonia', value: 'ee' },
  { label: 'Faroe Islands', value: 'fo' },
  { label: 'Finland', value: 'fi' },
  { label: 'France', value: 'fr' },
  { label: 'Georgia', value: 'ge' },
  { label: 'Germany', value: 'de' },
  { label: 'Ghana', value: 'gh' },
  { label: 'Gibraltar', value: 'gi' },
  { label: 'Greece', value: 'gr' },
  { label: 'Greenland', value: 'gl' },
  { label: 'Grenada', value: 'gd' },
  { label: 'Guatemala', value: 'gt' },
  { label: 'Guernsey', value: 'gg' },
  { label: 'Hong Kong', value: 'hk' },
  { label: 'Hungary', value: 'hu' },
  { label: 'Iceland', value: 'is' },
  { label: 'India', value: 'in' },
  { label: 'Indonesia', value: 'id' },
  { label: 'Ireland', value: 'ie' },
  { label: 'Isle of Man', value: 'im' },
  { label: 'Israel', value: 'il' },
  { label: 'Italy', value: 'it' },
  { label: 'Jamaica', value: 'jm' },
  { label: 'Japan', value: 'jp' },
  { label: 'Jersey', value: 'je' },
  { label: 'Kazakhstan', value: 'kz' },
  { label: 'Kenya', value: 'ke' },
  { label: 'Kuwait', value: 'kw' },
  { label: 'Kyrgyzstan', value: 'kg' },
  { label: 'Latvia', value: 'lv' },
  { label: 'Lebanon', value: 'lb' },
  { label: 'Liechtenstein', value: 'li' },
  { label: 'Lithuania', value: 'lt' },
  { label: 'Luxembourg', value: 'lu' },
  { label: 'Macau', value: 'mo' },
  { label: 'Macedonia', value: 'mk' },
  { label: 'Malaysia', value: 'my' },
  { label: 'Maldives', value: 'mv' },
  { label: 'Malta', value: 'mt' },
  { label: 'Marshall Islands', value: 'mh' },
  { label: 'Mauritius', value: 'mu' },
  { label: 'Mexico', value: 'mx' },
  { label: 'Moldova', value: 'md' },
  { label: 'Monaco', value: 'mc' },
  { label: 'Montenegro', value: 'me' },
  { label: 'Morocco', value: 'ma' },
  { label: 'Nauru', value: 'nr' },
  { label: 'Netherlands', value: 'nl' },
  { label: 'New Zealand', value: 'nz' },
  { label: 'Nicaragua', value: 'ni' },
  { label: 'Nigeria', value: 'ng' },
  { label: 'Northern Ireland', value: 'xi' },
  { label: 'Norway', value: 'no' },
  { label: 'Oman', value: 'om' },
  { label: 'Pakistan', value: 'pk' },
  { label: 'Panama', value: 'pa' },
  { label: 'Paraguay', value: 'py' },
  { label: 'Peru', value: 'pe' },
  { label: 'Philippines', value: 'ph' },
  { label: 'Poland', value: 'pl' },
  { label: 'Portugal', value: 'pt' },
  { label: 'Qatar', value: 'qa' },
  { label: 'Romania', value: 'ro' },
  { label: 'Russia', value: 'ru' },
  { label: 'Samoa', value: 'ws' },
  { label: 'San Marino', value: 'sm' },
  { label: 'Saudi Arabia', value: 'sa' },
  { label: 'Serbia', value: 'rs' },
  { label: 'Seychelles', value: 'sc' },
  { label: 'Singapore', value: 'sg' },
  { label: 'Sint Maarten', value: 'sx' },
  { label: 'Slovakia', value: 'sk' },
  { label: 'Slovenia', value: 'si' },
  { label: 'South Africa', value: 'za' },
  { label: 'South Korea', value: 'kr' },
  { label: 'Spain', value: 'es' },
  { label: 'Sri Lanka', value: 'lk' },
  { label: 'St. Kitts and Nevis', value: 'kn' },
  { label: 'St. Lucia Island', value: 'lc' },
  { label: 'St. Vincent and Grenadines', value: 'vc' },
  { label: 'Sweden', value: 'se' },
  { label: 'Switzerland', value: 'ch' },
  { label: 'Taiwan', value: 'tw' },
  { label: 'Tajikistan', value: 'tj' },
  { label: 'Thailand', value: 'th' },
  { label: 'Trinidad', value: 'tt' },
  { label: 'Tunisia', value: 'tn' },
  { label: 'Turkey', value: 'tr' },
  { label: 'Turkmenistan', value: 'tm' },
  { label: 'Ukraine', value: 'ua' },
  { label: 'United Arab Emirates', value: 'ae' },
  { label: 'United Kingdom', value: 'gb' },
  { label: 'United States', value: 'us' },
  { label: 'Uruguay', value: 'uy' },
  { label: 'Uzbekistan', value: 'uz' },
  { label: 'Vanuatu', value: 'vu' },
  { label: 'Venezuela', value: 've' },
  { label: 'Vietnam', value: 'vn' },
]
